import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'utils/modifiedTranslation';
import { addTreatment } from 'utils/static/icons';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    marginTop: 21,
    marginBottom: 21,
    border: '1px solid #FF8C69',
    borderRadius: 20,
    padding: '13px 36px',
    background: '#ff8c691a',
    cursor: 'pointer',
  },
  button: {
    padding: 0,
    fontSize: 16,
    textDecoration: 'underline',
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      textDecoration: 'underline',
    },
  },
  buttonLabel: {
    textTransform: 'capitalize',
    color: '#FF8C69',
    textDecoration: 'underline',
  },
  image: {
    marginRight: 16,
    '.rtl &': {
      marginRight: 0,
      marginLeft: 16,
    },
  },
}));

export const AddNewAnswer = ({ onClick, label }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div onClick={onClick} className={classes.root}>
      <Button
        onClick={onClick}
        color="inherit"
        classes={{
          root: classes.button,
          label: classes.buttonLabel,
        }}
      >
        <img src={addTreatment} alt="add-treatment" className={classes.image} />
        {t(label)}
      </Button>
    </div>
  );
};

AddNewAnswer.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};
